module.exports = __webpack_public_path__ + "img/401.b0bcfdd9.png";